module.exports = "https://cdn.hellotech.com/client-assets/video_doorbell_mobile_6cbf0c043ed73708c4fd4c7ae39f0a96.png";